/* eslint-disable import/prefer-default-export */
import * as yup from 'yup';

export const addBalanceSchema = yup.object({
  amount: yup
    .number()
    .typeError('Amount must be a number type')
    .required('Fill in the amount'),
});

export const paymentMethodSchema = yup.object({
  country: yup
    .string()
    .required('Country is required'),
});

export const billingDetailsSchema = yup.object({
  name: yup
    .string()
    .required('Full name is required'),
  country: yup
    .string()
    .transform((value) => (value ? value.trim() : value))
    .required('Country is required'),
});

export const redeemCouponSchema = yup.object({
  couponCode: yup
    .string()
    .required('Coupon code is required'),
});
